import script from "./AnnotationEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationEditor.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationEditor.vue?vue&type=style&index=0&id=18cc9ce5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cc9ce5"]])

export default __exports__